(function () {
  document.querySelectorAll('video-media[autoplay]').forEach(function (el) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'loaded' && el.hasAttribute('loaded')) {
          var video = el.querySelector('video');
          if (!video || video.readyState < 3) {
            el.removeAttribute('loaded');
            if (video) {
              video.addEventListener('canplay', function () {
                el.setAttribute('loaded', '');
                observer.disconnect();
              }, { once: true });
            }
          } else {
            observer.disconnect();
          }
        }
      });
    });
    observer.observe(el, { attributes: true, attributeFilter: ['loaded'] });
  });
})();
